import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyMobileTarget } from "@/lib/legacyMobile";

/** Legacy web-vue mobile routes (/m/*) map onto the single responsive app. */
export const Route = createFileRoute("/m/$")({
  beforeLoad: ({ params, location }) => {
    // Keep the query and hash, like the other legacy redirects.
    const hash = location.hash ? `#${location.hash}` : "";
    throw redirect({
      href: `${legacyMobileTarget(params._splat, location.searchStr)}${hash}`,
      replace: true,
    });
  },
});
